import { render, staticRenderFns } from "./ColorField.vue?vue&type=template&id=a2bcc682&scoped=true"
import script from "./ColorField.vue?vue&type=script&lang=ts"
export * from "./ColorField.vue?vue&type=script&lang=ts"
import style0 from "./ColorField.vue?vue&type=style&index=0&id=a2bcc682&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bcc682",
  null
  
)

export default component.exports